import Vue from 'vue'
import VeeValidate from 'vee-validate'
import vuetify from './plugins/vuetify'
import VueClipboard from 'vue-clipboard2'
import router from './router'
import App from './App.vue'

Vue.config.productionTip = false
Vue.use(VeeValidate)
Vue.use(VueClipboard)

// required to use clipboard in modal - https://github.com/Inndy/vue-clipboard2
VueClipboard.config.autoSetContainer = true

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
